import { PilotDoc } from '../types';

// the latest is the first
export function sortDocsByDate(documents: PilotDoc[], sortByEndDate = true) {
  return documents.sort((documentA, documentB) => {
    const dateA = sortByEndDate ? documentA.endDate : documentA.startDate;
    const dateB = sortByEndDate ? documentB.endDate : documentB.startDate;

    if (dateA && dateB) {
      return dateB.valueOf() - dateA.valueOf();
    } else {
      return 0;
    }
  });
}
